import React, { Component } from "react";
import { Modal, Spin, Table, Icon } from "antd";

class TopDomainsTableModal extends Component {
  constructor(props) {
    super(props);
    this.state = { visible: false };

    this.toggleModal = this.toggleModal.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.getDataSource = this.getDataSource.bind(this);
  }

  toggleModal(){
    this.setState(prevState => ({
      visible: !prevState.visible
    }));
  };

  handleOpenModal() {
    this.props.fetchTopDomains(this.props.keyword, this.props.seoDb);
    this.toggleModal();
  };

  columns = [
    { title: "#", dataIndex: "key" },
    { title: "Domain", dataIndex: "domain", className: "domain" },
    {
      title: "URL",
      dataIndex: "url",
      className: "top-domain-url",
      render: url => (
        <div>
          <a href={url} target="_blank" rel="noopener noreferrer">
            Visit URL
          </a>
        </div>
      )
    }
  ];

  getDataSource(topDomains){
    return topDomains.map((item, i) => ({
      key: i + 1,
      domain: item.domain,
      url: item.url
    }));
  }
    
  render() {
    return (
      <React.Fragment>
        {!this.props.isLoading ? (
          <span className="view-top-domains" onClick={this.handleOpenModal}>
            {this.props.openLabel}
          </span>
        ) : (
          <Spin style={{ lineHeight: "12px" }} indicator={<Icon type="loading" spin style={{ fontSize: 12 }} />} />
        )}

        {this.props.topDomains ? (
          <Modal
            centered
            className="top-domains-modal"
            title={this.props.modalTitle}
            visible={this.state.visible}
            onCancel={this.toggleModal}
            footer={null}>
            <Table
              className="top-domains"
              dataSource={this.getDataSource(this.props.topDomains)}
              columns={this.columns}
              pagination={false}
              size="small"
            />
          </Modal>
        ) : null}
      </React.Fragment>
    );
  }
}

export default TopDomainsTableModal;
